//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.Utils.ts							</Name>
//    <Description> Utilitky pro Adm Gridy						</Description>
//    <Author>      Tomáš Hažmuka								</Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019			</Copyright>
//    <Created>     2019-01-09									</Created>
//  </FileHeader>

namespace Gordic.Adm.GridUtils {

	export function setPreviewEmpty(panelElement: JQuery<HTMLElement>): void {
		var p7s_element = $("<div>").addClass("Adm-p7s-class");
		p7s_element.appendTo(panelElement);
		p7s_element.text("jres:32131043"); //RC 32131043 : Náhled není k dispozici.
	}

	// sidepanel pro grid
    export function setPanelGrid(title: string, row: any[] | null, gridFormat: Gordic.Data.GridFormat, panelElement: JQuery<HTMLElement>): void {

		//var datArray = ["dat_od", "dat_do", "dat_zmena", "dat_run_od", "dat_run_do"];

		if(row === null || row === undefined || row.length === 0) {
			GridUtils.setPreviewEmpty(panelElement);
		}
			else {
		/** vybraný řádek */
		var srow: any = row.length === 1 ? row[0] : row[row.length - 1];		// v případě single první s výběru, v případě multi poslední z výběru

		    var format = gridFormat;
			var columns = format.columns;
			var width = panelElement[0].clientWidth;
			var container = $("<div class='adm-sidebar-seznam js-sml {0}'>".format(width >= 500 ? "size-M" : "size-S" )).appendTo(panelElement);
			$("<div class='title'>").text(title).appendTo(container);
			var containerForm = $("<div class='form'>").appendTo(container);

			for (var i = 0; i < columns.length; i++) {
				var formRow = $("<div class='row'>").appendTo(containerForm);
				var caption = "";
				var valueEl = $("<div class='value'>")
				if (i == 0 && columns[i].name == "aktivita") {
					valueEl.attr("style", "height:20px;");
					caption = "jres:32131030"
					var value = getScopedObj(srow, columns[i].name || "");
					var text = "";
					var color = "";
					if (value != undefined) {
						switch (value) {
							case 100:
								text = "jres:33000139";
								color = "g-state-success"
								break;
							case 300:
								text = "jres:33000142"; //RC 33000142 : Připraven
								color = "g-state-info";
								break;
							case 500:
								text = "jres:33000140";
								color = "g-state-warning";
								break;
							case 600:
								text = "jres:33000141" //RC 33000141 : Návrh
								color = "g-state-info";
								break;
							default:
								text = "jres:33000143" //RC 33000143 : Zrušen
								color = "g-state-error"
								break;
						}
						$("<div>").appendTo(valueEl).gbadge({
							value: text,
							customClass: color
						})
                    }
				} else {
					var selectKey = columns[i];
					var field_name = selectKey.name || "";
					var value = getScopedObj(srow, field_name);
					if (value != undefined) {
						if (selectKey.columnType === "datetime") {
							if (selectKey.formatPreset === "DMRHMS") {
								value = value === null ? "" : Gordic.Templates.Formatters.datetime(value, 'datetime');;
							}
							else if (selectKey.formatPreset === "DMR") {
								value = value === null ? "" : Gordic.Templates.Formatters.datetime(value, 'date');;
							}
						}
					} else {
						value = value === null ? "" : value;
					}
					if (typeof (value) == "string")
						if (value.trim() == "") value = "—"
					valueEl.html(value);
					caption = selectKey.caption === undefined ? "undefined" : selectKey.caption;
				}
				$("<div class='label'>").appendTo(formRow).text("{0}:".format(caption));
				valueEl.appendTo(formRow);
            }

		//var container = $("<div class='Adm-panel-grid-container'>").appendTo(panelElement);
		//$("<div class='Adm-panel-grid-container-title'>").text(title).appendTo(container);
		//var table = $("<table class='Adm-panel-grid-table'>").appendTo(container);
		//var tbody = $("<tbody class='Adm-panel-grid-tbody'>").appendTo(table);

  //      for (var index = 0; index < columns.length; index++) {
  //          var selectKey = columns[index];

  //          console.log("selectKey :" + selectKey.name);

  //          var field_name = selectKey.name || "";
  //          var value = getScopedObj(srow, field_name);
  //          if (value != undefined) {

  //              if (selectKey.columnType === "datetime") {
  //                  if (selectKey.formatPreset === "DMRHMS") {
  //                      value = value === null ? "" : moment(value).format('DD.MM.YYYY HH:mm:ss');;
  //                  }
  //                  else if (selectKey.formatPreset === "DMR") {
  //                      value = value === null ? "" : moment(value).format('DD.MM.YYYY');;
  //                  }
  //              }
  //          }
  //          else {
  //              value = value === null ? "" : value;
  //          }

  //          var caption = selectKey.caption === undefined ? "undefined" : selectKey.caption;
  //          var element = $("<tr class='Adm-panel-grid-element'>").appendTo(tbody);
  //          $("<td class='Adm-panel-grid-element-title'>").appendTo(element).text(caption);					// title
  //          $("<td class='Adm-panel-grid-element-separator'>").appendTo(element).text(":");
  //          $("<td class='Adm-panel-grid-element-value'>").appendTo(element).text(value);				// value
            
  //      }

		//for (var key in srow) {

		//	for (var index = 0; index < columns.length; index++) {
		//		var selectKey = columns[index];

  //              console.log("key:" + key);
  //              console.log("selectKey :" + selectKey.name);

  //              if (key === selectKey.name) {						// je vybraný správný sloupec ( selectKey.name může obsahovat jména oddělená tečkou - key ale bude obahovat vždy jen první úroveň jména bez tečky ) 
                    
		//			var value = srow[key];
		//			for (var y = 0; y < datArray.length; y++) {

		//				if (key === datArray[y]) {				// prvek typu datum
		//					// může nastat u datumu - ošetření invalid date
		//					value = value === null ? "" : moment(value).format('DD.MM.YYYY HH:mm:ss');;
		//				}
		//			}

		//			var caption = selectKey.caption === undefined ? "undefined" : selectKey.caption;

		//			var element = $("<tr class='Adm-panel-grid-element'>").appendTo(tbody);
		//			$("<td class='Adm-panel-grid-element-title'>").appendTo(element).text(caption);					// title
		//			$("<td class='Adm-panel-grid-element-separator'>").appendTo(element).text(":");

		//			if (key === "resp_stat") {																		// hodnocení (sloupec)

		//				var valueElement = $("<td class='Adm-panel-grid-element-value'>").appendTo(element);
		//				var popis_txt = srow.popis_txt;																// popis hodnocení
		//				var hodnoceniEl = $("<i>").appendTo(valueElement);
		//				var hodnoceniText = $("<span>").appendTo(valueElement);




		//				if (value === WebControls.RespStatEnum.NeumimPosoudit) {
		//					hodnoceniEl.addClass("fa fa-question-circle g-state-text g-state-info");
		//					hodnoceniText.text(" - " + popis_txt);
		//				}
		//				else if (value === WebControls.RespStatEnum.VPoradku) {
		//					hodnoceniEl.addClass("fa fa-check g-state-text g-state-success");
		//					hodnoceniText.text(" - " + popis_txt);
		//				}
		//				else if (value === WebControls.RespStatEnum.ProblemNevyresen) {
		//					hodnoceniEl.addClass("fa fa-exclamation-triangle g-state-text g-state-warning");
		//					hodnoceniText.text(" - " + popis_txt);

		//				}
		//				else if (value === WebControls.RespStatEnum.Chyba) {
		//					hodnoceniEl.addClass("fa fa-exclamation-triangle g-state-text g-state-error");
		//					hodnoceniText.text(" - " + popis_txt);
		//				}
		//				else {
		//					// jiný - neměl by nastat
		//				}

		//			}
		//			else {
		//				$("<td class='Adm-panel-grid-element-value'>").appendTo(element).text(value);				// value
		//			}


		//		}
		//	}
		//}

	}

}

    /**
     * export function getColumnsName
     * 
     * Z GridFormat vytáhne jména sloupců gridu a vrátí jména sloupců
     * 
     * @param {Gordic.Data.GridFormat} gridFormat
     * @returns {string[]}
     */
    export function getColumnsName(gridFormat: Gordic.Data.GridFormat): string[] {
        let columnsName: string[] = [];
        let columns = gridFormat.columns;
        for (var index = 0; index < columns.length; index++) {
            var column = columns[index];
            if (column.name)
                columnsName.push(column.name);
        }
        return columnsName;
    }

     /**
     * export function getScopedObj
     * 
     * Přístup do vnořených položek zadané třídy na základě stringově definované cesty - Tedy to co lze přistoupit classInstance.item.subItem lze přistoupit také přes: getScopedObj(classInstance, "item.subItem")
     * 
     * https://stackoverflow.com/questions/6393943/convert-javascript-string-in-dot-notation-into-an-object-reference
     * 
     * @param {any} scope Instance třídy, k jejímž položkám chcete na základě stringové cesty přistupovat
     * @param {string} str Textově definovaná cesta k interním položkám zadané instance
     */
    export function getScopedObj(scope, str :string ) {
        let obj = scope, arr;
        try {
            arr = str.split(/[\[\]\.]/) // split by [,],.
                .filter(el => el)             // filter out empty one
                .map(el => el.replace(/^['"]+|['"]+$/g, '')); // remove string quotation
            arr.forEach(el => obj = obj[el])
        } catch (e) {
            obj = undefined;
        }
        return obj;
    } // getScopedObj

}